// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------

import './dist/index.js';
// reexport from bundle
export const Chart = window._____chartjses.Chart;
export const ChartAnnotation = window._____chartjses.ChartAnnotation;
export const ChartDataLabels = window._____chartjses.ChartDataLabels;
